const PB_URL = process.env.REACT_APP_PB_URL || '';

// Helper to get auth token from localStorage
export function getAuthToken() {
  try {
    const pbAuth = JSON.parse(localStorage.getItem('pocketbase_auth') || '{}');
    return pbAuth?.token || '';
  } catch {
    return '';
  }
}

// Fetch contacts by array of IDs
export const getContactsByIds = async (ids) => {
  try {
    const filterString = ids.map(id => `id='${id}'`).join(' || ');
    const response = await fetch(
      `${process.env.REACT_APP_PB_URL}/api/collections/Contacts/records?filter=${filterString}`,
      {
        headers: {
          'Content-Type': 'application/json',
        },
      }
    );
    
    if (!response.ok) throw new Error('Failed to fetch contacts');
    const data = await response.json();
    return data.items;
  } catch (error) {
    console.error('Error fetching contacts:', error);
    return {};
  }
};

// Fetch news and merge author info
export async function getNewsWithAuthors() {
  const token = getAuthToken();
  const res = await fetch(`${PB_URL}/api/collections/News/records`, {
    headers: {
      'Authorization': token ? `Bearer ${token}` : '',
      'Content-Type': 'application/json',
    },
  });
  if (!res.ok) throw new Error('Failed to fetch news');
  const data = await res.json();
  const news = data.items || [];
  // Collect unique author IDs
  const authorIds = Array.from(new Set(news.map(n => n.Author).filter(Boolean)));
  const contactsMap = await getContactsByIds(authorIds);
  // Merge author info into news
  return news.map(n => ({
    ...n,
    authorInfo: contactsMap.find(c => c.id === n.Author) || null,
  }));
} 